// imports
import { MouseEvent } from 'react';
import Link from 'next/link';
import { useAtom } from 'jotai';

// lib files
import { MyListConfirmModalTypeEnum, myListConfirmModalAtom } from '@/lib/atoms/my-list-confirm-modal';
import { ShowRowContent } from '@/lib/types/api/show-data';

// components
import KabobMenu from '@/components/KabobMenu/KabobMenu';
import ShowPoster from '@/components/ShowPoster/ShowPoster';

// svgs
import ShowsIcon from '@/public/svg/shows.svg';
import MinusIcon from '@/public/svg/minus.svg';

// styles
import styles from './MyListShowPoster.module.scss';
interface MyListShowPosterProps {
  show: ShowRowContent;
}
const MyListShowPoster = (props: MyListShowPosterProps) => {
  const {
    show
  } = props;
  const {
    slug,
    cid,
    title
  } = show;
  const [confirmModalState, setConfirmModalState] = useAtom(myListConfirmModalAtom);
  const handleRemoveClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const modalState = {
      id: cid,
      isOpen: true,
      slug: slug,
      title: title,
      type: MyListConfirmModalTypeEnum.SHOW
    };
    setConfirmModalState(modalState);
  };
  return <div className={styles.my_list_show} data-sentry-component="MyListShowPoster" data-sentry-source-file="MyListShowPoster.tsx">
      <ShowPoster show={show} data-sentry-element="ShowPoster" data-sentry-source-file="MyListShowPoster.tsx" />
      <KabobMenu className={styles.my_list_show_kabob_menu} contentClassName={styles.my_list_show_kabob_menu_content} data-sentry-element="KabobMenu" data-sentry-source-file="MyListShowPoster.tsx">
        <ul>
          <li>
            <Link href={`/show/${show.slug}/`} className={styles.my_list_show_link} data-sentry-element="Link" data-sentry-source-file="MyListShowPoster.tsx">
              <ShowsIcon data-sentry-element="ShowsIcon" data-sentry-source-file="MyListShowPoster.tsx" />
              Explore the Show
            </Link>
          </li>
          <li>
            <button className={styles.my_list_show_remove_button} onClick={handleRemoveClick}>
              <MinusIcon data-sentry-element="MinusIcon" data-sentry-source-file="MyListShowPoster.tsx" />
              Remove from My List
            </button>
          </li>
        </ul>
      </KabobMenu>
    </div>;
};
export default MyListShowPoster;